export const COLUMN_ID_1 = "pending";
export const COLUMN_ID_2 = "sent";
export const COLUMN_ID_3 = "interview";
export const COLUMN_ID_4 = "offer";
export const COLUMN_ID_5 = "accepted";
